/**
 * Pages
 */

export * from './pages/ArticleList/ArticleList';
export * from './pages/ArticleDetail/ArticleDetail';
